import { render, staticRenderFns } from "./PremiseWorkplace.vue?vue&type=template&id=3f452a96&"
import script from "./PremiseWorkplace.vue?vue&type=script&lang=js&"
export * from "./PremiseWorkplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f452a96')) {
      api.createRecord('3f452a96', component.options)
    } else {
      api.reload('3f452a96', component.options)
    }
    module.hot.accept("./PremiseWorkplace.vue?vue&type=template&id=3f452a96&", function () {
      api.rerender('3f452a96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/reporting/PremiseWorkplace.vue"
export default component.exports